/// <amd-module name="Test/Analytics/Common/Utils/FeatureFlagUtils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export function areReleaseEntitiesRemoved(pageContext: IVssPageContext): boolean {
    return isFeatureFlagEnabled(pageContext, "WebAccess.Test.Analytics.RemoveReleaseEntities", false);
}

export function isShowFlakyTestsDetailsEnabled(pageContext: IVssPageContext): boolean {
    return isFeatureFlagEnabled(pageContext, "WebAccess.Test.Analytics.ShowFlakyTestsDetails", false);
}

